import { Notification } from '../../model/Notification'
import { NotificationActionsTypes } from './NotificationTypes'

export const NotificationActions = {
  AddNotification: (key: string, notification: Notification) => ({
    type: NotificationActionsTypes.ADD_NOTIFICATION,
    key,
    notification,
    // meta: { debounce: { time: 250, leading: true, trailing: true } }
  }),
  ClearNotifications: () => ({
    type: NotificationActionsTypes.CLEAR_NOTIFICATION,
  }),
}
